import {
  createRouter,
  createWebHashHistory,
} from 'vue-router';
import Atlas from '@/pages/atlas/Atlas.vue';
import Details from '@/pages/details/Details.vue';
import { useFilterState } from '@/services/filter-state-service';
import { useQuery } from '@/services/query-service';

const routes = [{
  path: '/',
  name: 'Atlas',
  component: Atlas 
},
{
  path: '/details/:shipId',
  name: 'Details',
  component: Details,
  props: true
}
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// Wait until the router has resolved the initial URL..
router.isReady().then(() => {
  // ..and then map the query parameters to filters
  const filters = useQuery().mapQueriesToFilter(router.currentRoute.value.query);
  if (filters.length > 0) {
    useFilterState().setFilters(filters);
  }
})


export default router;
